import { Button, Grid } from "@mui/material";
import SideFeeds from "../components/SideFeeds";
import api from "../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SideAnnoncement from "../components/SideAnnoncement";


function Announcements() {

    const navigate = useNavigate();
    const [triggerRefresh, setTriggerRefresh] = useState(0)

    const [announcement, setAnnouncement] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");


    const postAnnouncement = async (e) => {
        e.preventDefault();

        const formData = {
            announcement,
            title,
            description,
        };

        try {
            const { data, status } = await api.post("annocements/", formData);
            if (data) {
                toast.success("Announcement Created successfully");
                setTriggerRefresh(prev => prev + 1)
            } else {
                toast.error("Failed to create Announcement");
            }
            setAnnouncement("");
            setTitle("");
            setDescription("");
            
        } catch (error) {
            console.error("Error creating Announcement:", error);
            toast.error("An error occurred while creating Announcement");
        }
        setShowAnnouncement(prev => !prev);
        console.log(false)
    };

    const [showAnnouncement, setShowAnnouncement] = useState(true);
    return (
        <>
            <div className="app-page-home">
                <Grid container spacing={2}>
                    <Grid item xs="12">
                        <div className="app-component-reportcard">
                            <div className="app-new-feeds">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} lg={6} className={showAnnouncement ? "app-page-home__feeds" : undefined}>
                                        <div className="app-component-reportcard">
                                            <div className="app-component-reportcard__head">
                                                <h4>Create Announcement</h4>
                                            </div>
                                            <div className="app-component-reportcard__count">
                                                <div className="form-group">
                                                    <label>Announcement</label>
                                                    <input value={announcement} onChange={(e) => setAnnouncement(e.target.value)} type="text" className="input-form" placeholder="Create Announcement" ></input>
                                                </div>
                                                <div className="form-group">
                                                    <label>Title</label>
                                                    <input value={title} onChange={(e) => setTitle(e.target.value)} type="text" className="input-form" id="" placeholder="MLANDS" ></input>
                                                </div>
                                                <div className="form-group">
                                                    <label>Description</label>
                                                    <textarea value={description} onChange={(e) => setDescription(e.target.value)} id="" className="input-form-2" rows="5" placeholder="Please share what you’re thinking"></textarea>
                                                </div>
                                            </div>
                                            <div className="create-post-button">
                                                <Button onClick={() => {setShowAnnouncement(prev => !prev)}} style={{backgroundColor:"gray", borderColor:"gray"}}>Cancel</Button>
                                                <Button onClick={postAnnouncement}>Create Announcement</Button>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} lg={6}>
                                        <div className={!showAnnouncement ? "app-page-home__feeds" : undefined}>
                                            <SideAnnoncement onClick={() => {setShowAnnouncement(prev => !prev)}}/>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default Announcements;